import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableSortLabel,
  TablePagination,
} from "@mui/material";
import OnSaleRow from "./OnSaleRow";
import { GroupedOffer } from "./types";

type SortField = "price" | "creationDate";
type SortDir = "asc" | "desc";

type Props = {
  groupedOffers: GroupedOffer[];
  multipleSteamAccounts: boolean;
  sortField: SortField;
  sortDir: SortDir;
  page: number;
  size: number;
  totalElements: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  onSortChange: (field: SortField, dir: SortDir) => void;
  onOffersDeleted: (ids: string[]) => void;
  onOffersUpdated: (updated: { offerId: string; price: number }[]) => void;
};

const OnSaleTable: React.FC<Props> = ({
                                        groupedOffers,
                                        sortField,
                                        sortDir,
                                        page,
                                        size,
                                        totalElements,
                                        onPageChange,
                                        onPageSizeChange,
                                        onSortChange,
                                        onOffersDeleted,
                                        onOffersUpdated,
                                      }) => {
  const handleSort = (field: SortField) => {
    const isAsc = sortField === field && sortDir === "asc";
    onSortChange(field, isAsc ? "desc" : "asc");
  };

  return (
      <div className="overflow-x-auto bg-neutral-900 rounded-lg p-4">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className="text-gray-300">Item</TableCell>

              <TableCell className="text-gray-300">
                <TableSortLabel
                    active={sortField === "price"}
                    direction={sortField === "price" ? sortDir : "asc"}
                    onClick={() => handleSort("price")}
                >
                  Price
                </TableSortLabel>
              </TableCell>

              <TableCell sx={{ display: { xs: "none", sm: "table-cell" } }} className="text-gray-300">
                Quantity
              </TableCell>

              <TableCell sx={{ display: { xs: "none", md: "table-cell" } }} className="text-gray-300">
                Steam User
              </TableCell>

              <TableCell sx={{ display: { xs: "none", md: "table-cell" } }} className="text-gray-300">
                Status
              </TableCell>

              <TableCell sx={{ display: { xs: "none", lg: "table-cell" } }} className="text-gray-300">
                Float
              </TableCell>

              <TableCell sx={{ display: { xs: "none", xl: "table-cell" } }} className="text-gray-300">
                <TableSortLabel
                    active={sortField === "creationDate"}
                    direction={sortField === "creationDate" ? sortDir : "asc"}
                    onClick={() => handleSort("creationDate")}
                >
                  Created
                </TableSortLabel>
              </TableCell>

              <TableCell className="text-gray-300">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {groupedOffers.map((g) => (
                <OnSaleRow
                    key={g.key}
                    offer={g}
                    onOffersDeleted={onOffersDeleted}
                    onOffersUpdated={onOffersUpdated}
                />
            ))}
          </TableBody>
        </Table>

        <TablePagination
            component="div"
            count={totalElements}
            page={page}
            onPageChange={(_, newPage) => onPageChange(newPage)}
            rowsPerPage={size}
            onRowsPerPageChange={(e) => onPageSizeChange(Number(e.target.value))}
            rowsPerPageOptions={[8, 25, 50, 100]}
        />
      </div>
  );
};

export default OnSaleTable;
